export default __webpack_public_path__ + "static/media/Engineering-Salary-Search.3560d5bd.png";